import { supabase } from "../lib/supabase";

export async function getNotesForProject(projectId) {
  const { data, error } = await supabase
    .from("project_notes")
    .select("*")
    .eq("project_id", projectId)
    .order("note_date", { ascending: false })
    .order("created_at", { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function createNote(projectId, payload) {
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  if (userError) throw userError;
  if (!user) throw new Error("Not logged in");

  const { data, error } = await supabase
    .from("project_notes")
    .insert([{
      user_id: user.id,
      project_id: projectId,
      title: payload.title || null,
      body: payload.body,
      note_date: payload.note_date || null,
      locked: payload.locked ?? false,
    }])
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function updateNote(noteId, patch) {
  const { data, error } = await supabase
    .from("project_notes")
    .update(patch)
    .eq("id", noteId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteNote(noteId) {
  const { error } = await supabase
    .from("project_notes")
    .delete()
    .eq("id", noteId);

  if (error) throw error;
}
